module.exports = __webpack_public_path__ + "static/homepage-delivery.5eaee576.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage-delivery.jpg
// module id = 506
// module chunks = 35783957827783